export function itemsBelongToSameAgency(items = []) {
  const agencyCodes = items
    .map((shipment) => shipment?.agency?.agency_code)
    .filter(Boolean);
  const uniqueAgencyCodes = [...new Set(agencyCodes)];

  return uniqueAgencyCodes.length === 1;
}
